import type { EffectiveReportViewHydraItem } from "@verbleif/lib/src/composables/Api/Type/ReportView/reportView.interface";
import { createGlobalState } from "@vueuse/core";
import { resourceKeys } from "../Query/resourceKeys";
import { createEffectiveViewsState } from "../ScopedViews/effectiveViewsState";

/** The effective report views of the signed-in user at the selected location, with view management and the list switcher. */
export const useReportViews = createGlobalState(() => createEffectiveViewsState<EffectiveReportViewHydraItem>({
  keys: resourceKeys.reportViews,
  collection: "effective_report_views",
  errorTitleKey: "reports.sidebar.views_load_failed",
  errorFallbackTitle: "Failed to load report views",
}));
